import { NodeWrapper } from "./NodeWrapper";
import { ArrowForwardIosOutlined as ArrowForwardIos, ContentCopyOutlined as ContentCopy, DeleteOutlined as Delete, VideocamOutlined as Videocam } from '@mui/icons-material';
import React, { memo, useContext } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { AuthContext } from "../../../context/Auth/AuthContext";
import { i18n } from "../../../translate/i18n";
import { mkHeaderStyle, HEADER_ICON_STYLE, HEADER_TEXT_STYLE, NODE_BODY_STYLE, NODE_INFO_ROW, mkInputHandleStyle, mkOutputHandleStyle } from "./nodeStyles";

import { Tooltip, IconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));
export default memo(({
  data,
  isConnectable,
  id,
  selected
}) => {
  const classes = useStyles();
  const {
    user
  } = useContext(AuthContext);
  const companyId = user?.companyId;
  const link = process.env.REACT_APP_BACKEND_URL === "http://localhost:8090" ? "http://localhost:8090" : process.env.REACT_APP_BACKEND_URL;

  // [ANTIGRAVITY] Fix: Extract ONLY the filename to avoid double-pathing and Windows backslash issues
  const filename = data.url ? data.url.split(/[/\\]/).pop() : "";
  const videoUrl = `${link}/public/company${companyId}/flow/${filename}`;
  const storageItems = useNodeStorage();
  return <NodeWrapper id={id} selected={selected} color="#00E676">
      <Handle type="target" position="left" style={mkInputHandleStyle("#00E676")} onConnect={params => console.log("handle onConnect", params)} isConnectable={isConnectable}>
      </Handle>

      
      <div style={{ ...mkHeaderStyle("#00E676"), justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Videocam style={HEADER_ICON_STYLE} />
          <div style={HEADER_TEXT_STYLE}>{data?.name || i18n.t("flowBuilder.editor.nodes.video.name")}</div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <HtmlTooltip
            title={
              <React.Fragment>
                <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#38bdf8' }}>
                  💡 {i18n.t("flowBuilder.tooltips.video.title")}
                </div>
                <div style={{ marginBottom: '0' }}>
                  <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.video.body") }} />
                </div>
              </React.Fragment>
            }
            placement="right"
          >
            <IconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
              <HelpOutlineIcon style={{ fontSize: '15px' }} />
            </IconButton>
          </HtmlTooltip>
        </div>
      </div>
      <div style={NODE_BODY_STYLE}>
        <div style={{ ...NODE_INFO_ROW, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <video key={videoUrl} controls="controls" style={{
        width: "100%",
        maxHeight: "150px",
        borderRadius: "4px",
        objectFit: "contain",
        backgroundColor: "#000"
      }} src={videoUrl}>
          {i18n.t("flowBuilder.editor.nodes.video.browserSupport")}
        </video>
      </div></div>
      <Handle type="source" position="right" id="a" style={{ ...mkOutputHandleStyle("#00E676"), top: "50%", transform: "translateY(-50%)" }} isConnectable={isConnectable}>
      </Handle>
    </NodeWrapper>;
});
